import { TOGGLE_FEEDBACK_MODAL } from 'constants/actionTypes.js';

export default function feedbackModal(state = { open: false }, { type }) {
    switch(type){
        case TOGGLE_FEEDBACK_MODAL:
            return { open: !state.open };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/feedbackModal.js